export default __webpack_public_path__ + "static/media/image2.14fe89cb.jpg";